import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getChartOfAccounts = ({ churchId, filters }) => {
  let url = `/churches/${churchId}/chart-of-accounts`;

  if (filters && filters.length > 0) {
    const filterParams = filters
      .map((filter, index) => {
        const values = Array.isArray(filter.value)
          ? filter.value.map(v => `filters[${index}][value][]=${v}`).join("&")
          : `filters[${index}][value]=${filter.value}`;

        return `filters[${index}][column]=${filter.column}&filters[${index}][operator]=${filter.operator}&${values}`;
      })
      .join("&");

    url = `${url}?${filterParams}`;
  }

  return axios.get(url);
};

export const useChartOfAccounts = ({ churchId, filters, config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ["chart-accounts", churchId, JSON.stringify(filters)],
    queryFn: () => getChartOfAccounts({ churchId, filters })
  });
};
